<template>
  <v-data-table
    :headers="displayHeaders"
    :items="items"
    :rows-per-page-items="[10]"
    class="inline-edit charge-list"
    hide-actions
  >
    <template slot="items" slot-scope="props">
      <td
        :class="{ 'text-xs-right': header.align === 'right', bordered: true }"
        :key="header.col"
        v-for="header in displayHeaders"
      >
        <span v-if="header.value === 'price'">{{
          props.item.price | currency
        }}</span>
        <span v-if="header.value === 'qty'">{{ props.item.qty }}</span>
        <span v-if="header.value === 'chargeItemScreenStatistics'"
          >{{ props.item.chargeItemName }}
          {{ props.item.containerTypeCode }}</span
        >
        <span v-if="header.value === 'originalSubTotal'">{{
          props.item.originalSubTotal | currency
        }}</span>
        <span v-if="header.value === 'currencyCode'">{{
          props.item.currencyCode
        }}</span>
        <span v-if="header.value === 'consumptionTaxCode'">{{
          props.item.consumptionTaxRate > 0 ? '課税' : '免税'
        }}</span>
        <span v-if="header.value === 'currencyRate'">{{
          props.item.currencyRate
        }}</span>
        <span v-if="header.value === 'originalJpySubTotal'">{{
          props.item.originalJpySubTotal | currency({ fractionCount: 0 })
        }}</span>
        <span v-if="header.value === 'subTotalAdjust'">
          <v-text-field
            :disabled="
              !canAdjust(props.item) ||
              !valueNotZero(props.item.originalSubTotal) ||
              props.item.isAgencyCommissionCharge
            "
            @change="
              (value) => adjustRequestValue(props.item, parseFloat(value))
            "
            @keydown="
              (e) => formatNumber(e, props.item.currencyCode === 'JPY' ? 0 : 2)
            "
            color="red"
            placeholder="调整金額"
            style="text-align: right"
            type="number"
            v-model="props.item.subTotalAdjust"
            v-show="
              props.item.adjustable || props.item.isAgencyCommissionCharge
            "
          />
        </span>
        <span
          v-if="header.value === 'subTotal'"
          v-show="props.item.adjustable || props.item.isAgencyCommissionCharge"
          >{{
            props.item.subTotal
              | currency({
                fractionCount:
                  props.item.currencyCode == null ||
                  props.item.currencyCode === 'JPY'
                    ? 0
                    : 2,
              })
          }}</span
        >
        <span
          v-if="header.value === 'paymentOriginalJpySubTotal'"
          v-show="props.item.adjustable && props.item.isPaymentCharge"
          >{{
            props.item.paymentOriginalJpySubTotal
              | currency({ fractionCount: 0 })
          }}</span
        >
        <span v-if="header.value === 'paymentSubTotalAdjust'">
          <v-text-field
            :disabled="
              !canAdjust(props.item) ||
              !valueNotZero(props.item.paymentOriginalSubTotal)
            "
            @change="
              (value) => adjustPaymentValue(props.item, parseFloat(value))
            "
            @keydown="
              (e) => formatNumber(e, props.item.currencyCode === 'JPY' ? 0 : 2)
            "
            color="red"
            placeholder="调整金額"
            style="text-align: right"
            type="number"
            v-model="props.item.paymentSubTotalAdjust"
            v-show="props.item.adjustable && props.item.isPaymentCharge"
          />
        </span>
        <span
          v-if="header.value === 'paymentSubTotal'"
          v-show="props.item.adjustable && props.item.isPaymentCharge"
          >{{
            props.item.paymentSubTotal
              | currency({
                fractionCount:
                  props.item.currencyCode == null ||
                  props.item.currencyCode === 'JPY'
                    ? 0
                    : 2,
              })
          }}</span
        >
        <v-text-field
          :disabled="!canAdjust(props.item)"
          clearable
          placeholder="コメント"
          style="width: 150px"
          v-if="header.value === 'comment'"
          v-model="props.item.comment"
          v-show="props.item.adjustable"
        />
        <remote-autocomplete
          :disabled="!canAdjust(props.item)"
          v-show="!props.item.isValueCharge"
          v-model="props.item.providerId"
          @change="providerChange(props.item)"
          :rules="
            props.item.isValueCharge
              ? []
              : [(v) => !!v || `諸掛請求先 is required`]
          "
          clearable
          placeholder="请输入諸掛請求先"
          url="overseas-providers/kv"
          v-if="header.value === 'providerId'"
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    shipment: Object,
    supplierId: String,
    columns: String,
    scope: String,
    hideAdditionalCharges: Boolean,
    columnHeaders: Object,
    ignoreSupplier: { type: Boolean, default: false },
    canAdjust: null,
  },
  data() {
    return {
      headers: [
        {
          text: '費用項目',
          value: 'chargeItemScreenStatistics',
          sortable: false,
          col: '0',
          width: 300,
        },
        {
          text: '請求金額',
          value: 'originalSubTotal',
          sortable: false,
          align: 'right',
          col: '1',
          width: 200,
        },

        {
          text: '通貨',
          value: 'currencyCode',
          sortable: false,
          col: '2',
          width: 200,
        },
        {
          text: '税区分',
          value: 'consumptionTaxCode',
          sortable: false,
          col: '3',
          width: 200,
        },
        {
          text: 'レート',
          value: 'currencyRate',
          sortable: false,
          align: 'right',
          col: '4',
          width: 100,
        },
        {
          text: '請求換算金額',
          value: 'originalJpySubTotal',
          sortable: false,
          align: 'right',
          col: '5',
          width: 200,
        },
        {
          text: '請求調整金額',
          value: 'subTotalAdjust',
          sortable: false,
          align: 'right',
          col: '6',
          width: 200,
        },
        {
          text: '請求調整後金額',
          value: 'subTotal',
          sortable: false,
          align: 'right',
          col: '7',
          width: 200,
        },

        {
          text: '支払換算金額',
          value: 'paymentOriginalJpySubTotal',
          sortable: false,
          align: 'right',
          col: '8',
          width: 200,
        },
        {
          text: '支払調整金額',
          value: 'paymentSubTotalAdjust',
          sortable: false,
          align: 'right',
          col: '9',
          width: 200,
        },
        {
          text: '支払調整後金額',
          value: 'paymentSubTotal',
          sortable: false,
          align: 'right',
          col: '10',
          width: 200,
        },

        {
          text: 'コメント',
          value: 'comment',
          sortable: false,
          col: '11',
          width: 200,
        },
        {
          text: '諸掛請求先',
          value: 'providerId',
          sortable: false,
          col: '12',
          width: 200,
        },
        {
          text: '単価',
          value: 'price',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '13',
        },
        {
          text: '数量',
          value: 'qty',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '14',
        },
      ],
    }
  },
  methods: {
    providerChange(item) {
      if (item.providerSeq === 1 && item.providerId) {
        this.items
          .filter((i) => i.providerSeq === 2 && this.canAdjust(i))
          .forEach((i) => (i.providerId = item.providerId))
      }
    },
    adjustRequestValue(charge, adjustValue) {
      if (
        adjustValue > 0 ||
        isNaN(charge.originalSubTotal + adjustValue) ||
        charge.originalSubTotal + adjustValue < 0
      ) {
        charge.subTotalAdjust = 0
        charge.subTotal = charge.originalSubTotal
      } else {
        charge.subTotal = charge.originalSubTotal + adjustValue
      }
    },
    adjustPaymentValue(charge, adjustValue) {
      if (
        isNaN(charge.paymentOriginalSubTotal + adjustValue) ||
        charge.paymentOriginalSubTotal + adjustValue < 0 ||
        adjustValue > 0
      ) {
        charge.paymentSubTotalAdjust = 0
        charge.paymentSubTotal = charge.paymentOriginalSubTotal
      } else {
        charge.paymentSubTotal = charge.paymentOriginalSubTotal + adjustValue
      }
    },
    formatNumber(e, precision) {
      var selObj = window.getSelection()
      if (
        selObj &&
        selObj.anchorNode &&
        selObj.anchorNode.childNodes[0] === e.target &&
        selObj.type === 'Range'
      ) {
        return false
      }
      if (precision === 0 && e.key === '.') {
        e.preventDefault()
      } else if (e.key === '.' && e.target.value.indexOf('.') !== -1) {
        e.preventDefault()
      } else if (
        e.key >= '0' &&
        e.key <= '9' &&
        e.target.value.indexOf('.') !== -1 &&
        e.target.value.length - e.target.value.indexOf('.') > precision
      ) {
        e.preventDefault()
      }
    },
    notExist(value) {
      return value == undefined || value == null
    },
    valueNotZero(value) {
      return !this.notExist(value) && value != 0
    },
    getChargeSortWeight(charge) {
      var maxGroup = ['商品代金', 'SJL Commission', '保険費']
      if (maxGroup.indexOf(charge.chargeItemName) !== -1) {
        return 10000 + maxGroup.indexOf(charge.chargeItemName)
      }
      return parseInt(charge.chargeItemSeq)
    },
    getCharges() {
      return this.items
    },
  },
  computed: {
    filterCharges() {
      let charges =
        this.shipment &&
        this.shipment.charges &&
        this.shipment.charges
          // .filter(i => !i.isCCFeeCharge && 'LOCAL-006' != i.chargeItemCode)
          .filter((i) => !this.hideAdditionalCharges || !i.isAdditionalCharge)
          .filter(
            (i) =>
              !this.scope ||
              (i.chargeItemScopes &&
                i.chargeItemScopes.indexOf(this.scope) !== -1)
          )
          .filter(
            (i) =>
              i.chargeItemName &&
              i.chargeItemCode &&
              (i.chargeItemName.indexOf('税') === -1 ||
                i.chargeItemCode.indexOf('LOCAL') === -1)
          )
          .filter(
            (i) =>
              this.valueNotZero(i.originalJpySubTotal) ||
              this.notExist(i.containerTypeId) ||
              i.containerTypeId === ((this.shipment.packages && this.shipment.packages[0]) || {}).containerTypeId ||
              i.qty!=0
          )
          .filter((i) => i.qty || i.originalSubTotal || i.isCCFeeCharge) //既没有数量，又没有金额，不应该显示
          .sort(
            (a, b) => this.getChargeSortWeight(a) - this.getChargeSortWeight(b)
          )

      if (charges) {
        let first = charges.find(
          (i) => (this.shipment.isDo ? !i.isFreight : true) && !i.isValueCharge
        )
        if (first != null) {
          first.providerSeq = 1
          charges
            .filter((i) => i.id !== first.id)
            .forEach((i) => (i.providerSeq = 2))
        }
      }

      return charges
    },
    items() {
      if (this.ignoreSupplier) {
        return this.filterCharges
      } else {
        return this.filterCharges.filter(
          (s) => s.supplierId === this.supplierId
        )
      }
    },
    displayHeaders() {
      if (this.columns) {
        return this.columns.split(',').map((c) => {
          let header = this.headers.find((h) => h.col === c)
          if (header) {
            header.text =
              (this.columnHeaders && this.columnHeaders[c]) || header.text
          }
          return header
        })
      } else {
        return this.headers
      }
    },
  },
}
</script>
<style scoped>
.bordered {
  border: 0px solid red;
}

.column {
  color: black;
}
.charge-list /deep/ .v-datatable td {
  font-size: 15px;
}

.charge-list /deep/ .v-datatable th {
  font-size: 15px !important;
  color: #369;
}
</style>


